import { render, staticRenderFns } from "./DailyStatistics.vue?vue&type=template&id=e1098e70&scoped=true"
import script from "./DailyStatistics.vue?vue&type=script&lang=js"
export * from "./DailyStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1098e70",
  null
  
)

export default component.exports